import md5 from "md5";
import { loginWap } from "@/views/api/user";
import jwt from "jsonwebtoken";
import axios from "axios";
// const TokenKey = "Admin-Token";
const InformationKey = "info";
const FlagKey = "flag";
const LanguageKey = "language";
const refreshTokenKey = "refreshToken";
const TokenKey = "token-admin-edu-fram";

export function setToken(token) {
  console.log(token);
  axios.defaults.headers.common["X-Access-Token"] = token;
  return localStorage.setItem(TokenKey, token);
}
export function setRefreshToken(refreshToken) {
  localStorage.setItem(refreshTokenKey, refreshToken);
}

export function getRefreshToken() {
  return localStorage.getItem(refreshTokenKey);
}

export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function decodeToken() {
  let token = getToken();
  return jwt.decode(token);
}

export function getInfo() {
  if (localStorage.getItem(InformationKey))
    return JSON.parse(localStorage.getItem(InformationKey));
  return {
    user_id: "",
    token: "",
    fullname: ""
  };
}
export const setInfo = info =>
  localStorage.setItem(InformationKey, JSON.stringify(info));

export function setInfoLogin(info) {
  localStorage.setItem(
    InformationKey,
    JSON.stringify({
      vga: info.vga,
      token: info.token,
      fullname: info.fullname
    })
  );
}

export const removeInfo = () => localStorage.removeItem(InformationKey);

export const getFlag = () => localStorage.getItem(FlagKey);

export const setFlag = flag => localStorage.setItem(FlagKey, flag);

export const removeFlag = () => localStorage.removeItem(FlagKey);

export const getLanguage = () => localStorage.getItem(LanguageKey);

export const setLanguage = lang => localStorage.setItem(LanguageKey, lang);

export const removeLanguage = () => localStorage.removeItem(LanguageKey);

export async function setupLoginWap(self) {
  let currentUrl = window.location.host;
  if (currentUrl == "localhost:8080") {
    if (!checkTokenExists()) {
      console.log("checkTokenExists()", checkTokenExists());
      if (checkSignData(self)) {
        let dataLogin = {
          phone: self.$router.history.current.query.phone,
          signdata: renderSignData(self.$router.history.current.query.phone)
        };

        await loginWap(dataLogin).then(res => {
          if (res.error_code === 200) {
            localStorage.setItem(InformationKey, JSON.stringify(res.data.data));
            window.location.href = window.location.href;
          }
        });
      }
    }
  }
}

export function renderSignData(phone) {
  let secretKey = process.env.VUE_APP_SECRET_KEY;
  return md5(secretKey + phone);
}

export function checkTokenExists() {
  let token = getToken().token;
  return !!token.length;
}

export function checkSignData(self) {
  let params = self.$router.history.current.query;
  if ("signdata" in params && "phone" in params) {
    let signdata = params.signdata;
    let phone = params.phone;
    if (signdata.length && phone.length) {
      let signDataRender = renderSignData(phone);
      return signDataRender === signdata;
    }
  } else {
    return false;
  }
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}
